import { appConfig } from '@/config/app';
import type { EventEnvelope } from '@/api/types';
import {
  getOrCreateSessionId,
  getOrCreateVisitorId,
  newEventId,
  readAttribution,
  takeSessionReferrer,
} from './attribution';
import type { AppEventType } from './events';

export interface TrackData {
  button?: string;
  metadata?: Record<string, unknown>;
  correlation_id?: string;
}

/** Поверхность: публичный канвас (и его legacy-адрес) считается отдельно (TRK-3). */
export function currentSurface(
  pathname: string = window.location.pathname,
): 'app' | 'shared_board' {
  return /\/(shared|boards\/shared)\//.test(pathname) ? 'shared_board' : 'app';
}

function currentLocale(): string | undefined {
  if (typeof document !== 'undefined' && document.documentElement.lang)
    return document.documentElement.lang;
  return typeof navigator !== 'undefined' ? navigator.language?.slice(0, 8) : undefined;
}

/** Конверт schema_version 2 (TRK-2). */
export function buildEnvelope(type: AppEventType, data: TrackData = {}): EventEnvelope {
  const attribution = readAttribution() ?? {};
  const envelope: EventEnvelope = {
    event_id: newEventId(),
    client_ts: new Date().toISOString(),
    schema_version: 2,
    surface: currentSurface(),
    app_build: appConfig.appBuild,
    locale: currentLocale(),
    visitor_id: getOrCreateVisitorId(),
    session_id: getOrCreateSessionId(),
    event_type: type,
    page: window.location.pathname,
  };

  if (data.button) envelope.button = data.button;
  if (data.metadata) envelope.metadata = data.metadata;
  if (data.correlation_id) envelope.correlation_id = data.correlation_id;

  const referrer = takeSessionReferrer();
  if (referrer) envelope.referrer = referrer;

  if (attribution.utm_source) envelope.utm_source = attribution.utm_source;
  if (attribution.utm_medium) envelope.utm_medium = attribution.utm_medium;
  if (attribution.utm_campaign) envelope.utm_campaign = attribution.utm_campaign;
  if (attribution.utm_content) envelope.utm_content = attribution.utm_content;
  if (attribution.utm_term) envelope.utm_term = attribution.utm_term;

  return envelope;
}
